export const state = {
  errors: []
}

export const getters = {
  errors: (state) => {
    return state.errors
  },
  error: (state) => (field) => {
    if (state.errors[field]) {
      return state.errors[field][0]
    }
    return null
  }
}

export const mutations = {
  SET_ERRORS: (state, errors) => {
    state.errors = errors
  },
  RESET_ERRORS: (state) => {
    state.errors = []
  }
}
